import { UseGetFlag } from "../../app/launchDarkly"
import GoogleTranslate from "./GoogleTranslate";

const I18n = ({ children }: { children: any }) => {

  const { i18n } = UseGetFlag();

  return (
    <>
      {i18n.length > 0 ? <GoogleTranslate language={i18n[0]} /> : null}
      {children}
    </>
  )
}

export default I18n;